import { MessageHubResponse } from '@acme/api';

export interface ChatIdentifier {
  type: 'personal' | 'ticket';
  ticketId?: string;
}

export interface MessageHubMessage extends MessageHubResponse {
  chatId: string;
}

export const createChatId = (identifier: ChatIdentifier): string => {
  if (identifier.type === 'ticket' && identifier.ticketId) {
    return `ticket:${identifier.ticketId}`;
  }
  return 'personal';
};

export const parseChatId = (chatId: string): ChatIdentifier => {
  if (chatId.startsWith('ticket:')) {
    return {
      type: 'ticket',
      ticketId: chatId.replace('ticket:', ''),
    };
  }
  return { type: 'personal' };
};

export const getChatIdFromMessage = (message: MessageHubResponse): string => {
  if (message.ticketId) {
    return `ticket:${message.ticketId}`;
  }
  return 'personal';
};
